import { NotificationItem, notify } from '@ps-int/ps-components/src/notifications/slice';
import { PayloadAction } from '@reduxjs/toolkit';
import { call, put } from 'typed-redux-saga';

import { copy } from '../../../shared/helpers/clipboard';

export function* copyToClipboardSaga(action: PayloadAction<{ value: string; notificationItem: NotificationItem }>) {
    const isSuccess = yield* call(copy, action.payload.value, true);
    if (isSuccess) {
        yield* put(notify(action.payload.notificationItem));
    }
}
